import React from 'react';
import { cx } from 'linaria';
import { Skeleton } from 'fronton-react';
import {
  SkeletonContainer,
  skeletonBase,
  firstSkeleton,
  secondSkeleton,
  skeletonInnerContainer,
} from './styles';

export const DATA_QA_SKELETON_CONTAINER = 'yandex-split-banner-skeleton-container';

export const YandexSplitBannerSkeleton = () => {
  return (
    <SkeletonContainer data-qa={DATA_QA_SKELETON_CONTAINER}>
      <div className={skeletonInnerContainer}>
        <Skeleton variant="display" className={cx(skeletonBase, firstSkeleton)} />
        <Skeleton variant="display" className={cx(skeletonBase, secondSkeleton)} />
      </div>
    </SkeletonContainer>
  );
};
